<nav class="flex justify-center items-center lg:px-6 mobile-full-width h-11 bg-white  overflow-hidden"
  (mouseenter)="updateOnNavBar(true)" (mouseleave)="updateOnNavBar(false)">
  <ul class="flex justify-between items-center h-full w-full relative" #menuContainer>
    <li mat-ripple class="h-full w-1/6 md:w-1/12 text-center font-bold whitespace-nowrap hover:bg-gray-200 transition-all duration-200">
      <button [ngClass]="accommodation == 'hotel' ? 'facilities' : 'generalinfo'"
        class="w-full h-full text-black-300 text-base inline-flex items-center justify-center"
        (click)="activateItem(0, false, false)" (mouseenter)="activateItem(0, true, false, true)" #menuItem>
        {{ accommodation == 'hotel' ? 'امکانات' : 'مشخصات'}}
      </button>
    </li>
    <li mat-ripple class="h-full w-1/6 md:w-1/12 text-center font-bold whitespace-nowrap hover:bg-gray-200 transition-all duration-200">
      <button [ngClass]="accommodation == 'hotel' ? 'rooms' : 'calender'"
        class="w-full h-full text-black-300 text-base inline-flex items-center justify-center"
        (click)="activateItem(1, false, false)" (mouseenter)="activateItem(1, true, false, true)" #menuItem>
        {{ accommodation == 'hotel' ? 'اتاق ها' : 'تقویم'}}
      </button>
    </li>
    <li mat-ripple class="h-full w-1/6 md:w-1/12 text-center font-bold whitespace-nowrap hover:bg-gray-200 transition-all duration-200">
      <button class="w-full h-full text-black-300 text-base inline-flex items-center justify-center rules"
        (click)="activateItem(2, false, false)" (mouseenter)="activateItem(2, true, false, true)" #menuItem>
        قوانین
      </button>
    </li>
    <li mat-ripple class="h-full w-1/6 md:w-1/12 text-center font-bold whitespace-nowrap hover:bg-gray-200 transition-all duration-200">
      <button [ngClass]="accommodation == 'hotel' ? 'distances' : 'map'"
        class="w-full h-full text-black-300 text-base inline-flex items-center justify-center"
        (click)="activateItem(3, false, false)" (mouseenter)="activateItem(3, true, false, true)" #menuItem>
        {{ accommodation == 'hotel' ? 'فاصله ها' : 'موقعیت'}}
      </button>
    </li>
    <li #about mat-ripple
      class="h-full w-1/6 md:w-1/12 text-center font-bold whitespace-nowrap hover:bg-gray-200 transition-all duration-200">
      <button class="w-full h-full text-black-300 text-base inline-flex items-center justify-center comments"
        (click)="activateItem(4, false, false)" (mouseenter)="activateItem(4, true, false, true)" #menuItem>
        نظرات
      </button>
    </li>
    <li class="absolute w-1/6 md:w-1/12 right-0 bottom-0 transition-all duration-300" #activeSymbol>
      <div
        class="flex justify-center items-center after:hidden after:md:block w-full h-[3px] rounded-lg shadow-2xl !shadow-blue-500 bg-blue-500 after:bg-blue-500 after:absolute after:-top-[1px] after:-z-10 after:w-[110%] after:h-5 after:rounded-md">
      </div>
    </li>
  </ul>
</nav>